<template>
  <v-data-table
    :headers="headers"
    item-key="id"
    :items="workorders"
    :search="search"
    :loading="loading"
    no-data-text="Nothing to see here..."
    no-results-text="You filtered a little too hard there bud..."
    :items-per-page="50"
    show-expand
  >
    <template v-slot:item.forgeID="{ item }">
      <WorkOrderNavigation :instance="item" />
    </template>
    <template v-slot:item.coating.name="{ item }">
      {{ item.coating.name }}
    </template>
    <template v-slot:item.material.name="{ item }">
      <MaterialChip :material="item.material" />
    </template>
    <template v-slot:item.state.name="{ item }">
      <StateChip :state="item.state" />
    </template>
    <template v-slot:item.children.count="{ item }">
      <v-badge small>
        <template v-slot:badge>
          {{ item.children.length }}
        </template>
        <v-icon small>fas fa-cube</v-icon>
      </v-badge>
    </template>
    <template v-slot:item.action="{ item }">
      <div class="d-flex">
        <WorkOrderForm
          :is-edit="true"
          :is-duplicate="false"
          :instance="item"
          :projid="item.project_id"
        />
        <WorkOrderForm
          :is-edit="false"
          :is-duplicate="true"
          :instance="item"
          :projid="item.project_id"
        />
      </div>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <div v-html="item.richtext" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import WorkOrderForm from "./WorkOrderForm";
import WorkOrderNavigation from "./WorkOrderNavigation";
import MaterialChip from "../Material/MaterialChip";
import StateChip from "../State/StateChip";
export default {
  name: "WorkOrderTable",
  components: {
    StateChip,
    MaterialChip,
    WorkOrderForm,
    WorkOrderNavigation
  },
  props: {
    search: {
      type: String,
      required: true,
      default: ""
    },
    workorders: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: "ID", align: "left", sortable: true, value: "forgeID" },
        { text: "Title", sortable: true, value: "name" },
        {
          text: "Status",
          sortable: true,
          align: "center",
          value: "state.name"
        },
        {
          text: "Coating",
          sortable: false,
          value: "coating.name",
          align: "center"
        },
        {
          text: "Substrate",
          sortable: false,
          value: "material.name",
          align: "center"
        },
        { text: "Batches", sortable: true, value: "children.count" },
        { text: "Actions", sortable: false, align: "center", value: "action" }
      ]
    };
  }
};
</script>
